import * as R from 'ramda';

export function insertBreaks(rawCopy) {
	if (rawCopy) {
		rawCopy = rawCopy.replace('\n', '<br/>');
		rawCopy = rawCopy.replace('  ', '\t');
		return { __html: rawCopy.replace('\n', '<br/>') };
	}
}

export function getAllPaths(arr) {
	const pathArr = arr.map(key => key.node.path.replace(/\/$/, ''));
	return pathArr;
}

//https://gist.github.com/simonw/c29de00c20fde731243cbac8568a3d7f
export function debounce(fn, delay) {
	let timer = null;
	return function(...args) {
		const context = this;
		timer && clearTimeout(timer);
		timer = setTimeout(() => {
			fn.apply(context, args);
		}, delay);
	};
}

// https://github.com/ramda/ramda/wiki/Cookbook#flatten-a-nested-object-into-dot-separated-key--value-pairs
export function flattenObj(obj) {
	const go = obj_ =>
		R.chain(([k, v]) => {
			if (R.type(v) === 'Object' || R.type(v) === 'Array') {
				return R.map(([k_, v_]) => [`${k}.${k_}`, v_], go(v));
			} else {
				return [[k, v]];
			}
		}, R.toPairs(obj_));

	return R.fromPairs(go(obj));
}

export function checkIfEmpty(arr) {
	//keeping this until we're really, really sure we don't need it
	const checkForObj = R.filter(function(x) {
		return R.type(x) !== 'Object' ? x : '';
	});

	if (arr) {
		const reduce = R.reduce(
			(allEmpty, obj) => {
				let trimObj = R.map(R.trim, checkForObj(R.values(obj)));
				if (!R.all(R.isEmpty, R.values(trimObj))) {
					allEmpty = true;
				}
				return allEmpty;
			},
			false,
			arr
		);
		return reduce;
	} else {
		return true;
	}
}

// https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
export function sortByUid(a, b) {
	const aId =
		a.node && a.node.context ? a.node.context.uid 
		: a.node ? a.node.uid 
		: a.uid;
	const bId =
		b.node && b.node.context ? b.node.context.uid 
		: b.node ? b.node.uid 
		: b.uid;
	let comparison = 0;
	if (aId > bId) {
		comparison = 1;
	} else if (aId < bId) {
		comparison = -1;
	}
	return comparison;
}

export function sortByFootnote(a, b) {
	const aId = a.footNum;
	const bId = b.footNum;
	let comparison = 0;
	if (aId > bId) {
		comparison = 1;
	} else if (aId < bId) {
		comparison = -1;
	}
	return comparison;
}
export const mapArrIndexed = R.addIndex(R.map);
